<div class="spawns-tab display-flex gap-16">
  <div class="map-panel">
    <div id="cards-map-div" class="map-display"></div>
  </div>

  <div class="side-panel display-flex vertical gap-12">
    <p class="hint-text regular-14">{{ 'clickMapToSetLocation' | transloco }}</p>

    <p class="semibold-14 coords-readout">
      @if (clickedCoords(); as coords) {
        {{ coords.lng }}, {{ coords.lat }}
      } @else {
        <span class="regular-14 color-soft-grey">&mdash;</span>
      }
    </p>

    <select class="select-input" [formControl]="selectedCardId">
      <option [ngValue]="null" disabled selected>Select card&hellip;</option>
      @for (c of cards.value(); track c.id) {
        <option [ngValue]="c.id">{{ c.name.en }} &middot; {{ c.rarity }} &middot; {{ c.value }}</option>
      }
    </select>

    <input type="number" class="number-input" [formControl]="expiresDays" [placeholder]="'cardsAdminNoExpiry' | transloco" min="1" />

    <button type="button" class="primary-btn" [disabled]="!clickedCoords() || !selectedCardId.value" (click)="createSpawn()">
      {{ 'create' | transloco }}
    </button>
  </div>
</div>

<div class="spawn-list display-flex vertical gap-12 margin-top-24">
  @if (spawns.isLoading()) {
    <p class="regular-14">{{ 'loading' | transloco }}</p>
  } @else if (!spawns.value().length) {
    <p class="regular-14">{{ 'noResultsFound' | transloco }}</p>
  } @else {
    @for (s of spawns.value(); track s.id) {
      <div class="spawn-row display-flex gap-12">
        <img [src]="s.thumbUrl" width="40" [alt]="s.cardName.en" />
        <span class="semibold-14 card-name">{{ s.cardName.en }}</span>
        <span class="regular-14 color-soft-grey">{{ s.rarity }}</span>
        <span class="regular-14" [class.color-green]="s.isAdminSpawn">{{ s.isAdminSpawn ? 'Admin' : 'Player' }}</span>
        <span class="regular-14 color-soft-grey expires-cell">
          @if (s.expiresAt) {
            {{ s.expiresAt | date }}
          } @else {
            {{ 'cardsAdminNoExpiry' | transloco }}
          }
        </span>
        <button type="button" class="warning-bar-btn" (click)="deleteSpawn(s.id)">{{ 'cardsAdminExpire' | transloco }}</button>
      </div>
    }
  }
</div>
